import React, { useEffect, useState } from 'react';

import { Stack, TextField } from '@mui/material';

import { PopUp } from 'components/PopUp';

import { PopUpButtonProps } from 'types';

interface LinkInputPopUpProps {
  isOpen: boolean;
  close: () => void;
  onSubmit: (url: string, text?: string) => void;
  initialUrl?: string;
  initialText?: string;
  title?: string;
  onClear?: () => void;
}

export const LinkInputPopUp = ({
  isOpen,
  close,
  onSubmit,
  initialUrl = '',
  initialText = '',
  title = 'Add Link',
  onClear,
}: LinkInputPopUpProps) => {
  const [url, setUrl] = useState(initialUrl);
  const [text, setText] = useState(initialText);

  useEffect(() => {
    if (isOpen) {
      setUrl(initialUrl);
      setText(initialText);
    }
  }, [isOpen, initialUrl, initialText]);

  const handleSubmit = () => {
    onSubmit(url, text);
    resetForm();
    close();
  };

  const resetForm = () => {
    setUrl('');
    setText('');
  };

  const buttons: PopUpButtonProps[] = [
    {
      name: 'CANCEL',
      handler: () => {
        resetForm();
        close();
      },
      variant: 'outlined',
    },
    {
      name: 'CLEAR',
      handler: () => {
        if (onClear) {
          onClear();
        }
        resetForm();
        close();
      },
      variant: 'outlined',
    },
    {
      name: 'SUBMIT',
      handler: handleSubmit,
      variant: 'contained',
    },
  ];

  return (
    <PopUp
      isPopUpOpen={isOpen}
      title={title}
      buttons={buttons}
      close={() => {
        resetForm();
        close();
      }}
      maxWidth="sm"
      fullWidth
      disableCTA={!url.trim()}
    >
      <Stack direction="column" spacing={2} width="100%">
        <TextField
          label="URL"
          fullWidth
          required
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="Enter URL (e.g., https://example.com)"
        />
        <TextField
          label="Link Text"
          fullWidth
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Enter link text (optional)"
          helperText="Leave empty to use the URL as the link text"
        />
      </Stack>
    </PopUp>
  );
};
